import { render, staticRenderFns } from "./WholeNetworkPage.vue?vue&type=template&id=463d90b0&scoped=true"
import script from "./WholeNetworkPage.vue?vue&type=script&lang=js"
export * from "./WholeNetworkPage.vue?vue&type=script&lang=js"
import style0 from "./WholeNetworkPage.vue?vue&type=style&index=0&id=463d90b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463d90b0",
  null
  
)

export default component.exports